export default {
    props: {
      data: {
        Type: Object
      }
    },
    created() {
      this.form = this.data;
      this.onInput(this.form);
      console.log('OrderConsult Modal Created', this.data);
    },
    methods: {
      onInput(val) {
        this.$bus.$emit("input", val);
      },
      closeModal() {
          this.$parent.close();
      }
    },
    // watch: {
    //   data: { 
    //     immediate: true,
    //     deep: true,
    //     handler(value) {
    //       this.form = value;
    //     }
    //   }
    // }
  };
  